.root {
  width: 12.5rem;

  .wrapper {
    height: 3rem;
  }

  .label {
    color: var(--mantine-color-primary-7);
    margin-bottom: 6px;
    font-size: 1rem;
    font-weight: 600;
  }

  .input {
    height: 100%;
    border: 1px solid var(--mantine-color-tertiary-2);
    background: var(--mantine-color-otherWhite-0);
    opacity: 1;
    color: var(--mantine-color-primary-7);
    font-size: 1rem;
    letter-spacing: -0.2rem;

    &::placeholder {
      color: var(--mantine-color-tertiary-7);
    }

    &:focus-within {
      border: 1px solid var(--mantine-color-tertiary-9);
    }

    &:active {
      border: 1px solid var(--mantine-color-tertiary-2);
    }

    &[data-disabled='true'] {
      opacity: 1;
      background-color: var(--mantine-color-tertiary-0);
      border: 1px solid var(--mantine-color-tertiary-0);

      &::placeholder {
        color: var(--mantine-color-tertiary-2);
      }
    }
  }

  &[data-size='sm'] {
    .label {
      font-size: 0.875rem;
    }

    .wrapper {
      height: 2.625rem;
    }
  }

  &[data-error='true'] {
    .input {
      border: 1px solid var(--mantine-color-red-7);
      color: var(--mantine-color-red-7);
      background-color: var(--mantine-color-primary-0);

      &::placeholder {
        color: var(--mantine-color-red-7);
      }
    }
  }

  &[data-variant='filled'] {
    .input {
      background: var(--mantine-color-primary-0);
      border: var(--mantine-color-primary-0);

      &:focus-within {
        border: 1px solid var(--mantine-color-tertiary-2);
        background: var(--mantine-color-primary-0);
      }

      &:active {
        background: var(--mantine-color-primary-0);
      }
    }
  }

  &[data-variant='unstyled'] {
    .input {
      background: transparent;
      background-color: transparent;
      border: none;

      &:focus-within {
        background: transparent;
        background-color: transparent;
        border: none;
      }

      &:active {
        background: transparent;
        background-color: transparent;
        border: none;
      }

      &[data-disabled='true'] {
        opacity: 1;
        background-color: var(--mantine-color-tertiary-0);
        border: 1px solid var(--mantine-color-tertiary-0);

        &::placeholder {
          color: var(--mantine-color-tertiary-2);
        }
      }
    }

    .innerInput {
      padding: 0.75rem;
    }

    &[data-error='true'] {
      .input {
        border: 1px solid var(--mantine-color-red-7);

        &::placeholder {
          color: var(--mantine-color-red-7);
        }
      }
    }
  }
}
